import EditIcon from "@mui/icons-material/Edit";
import { Box, Chip, IconButton, Paper, Typography } from "@mui/material";
import { useState } from "react";
import usePost from "../../app/usePost";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import AnswerItems from "../anwser/AnwerItems";
import { Question } from "../exam/type";
import QuestionUpdateForm from "./QuestionUpdateForm";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";

function QuestionItem({
  question,
  showAnswers = false,
  showSection = false,
}: {
  question: Question;
  showAnswers?: boolean;
  showSection?: boolean;
}) {
  const [stateQuestion, setStateQuestion] = useState(question);
  const { post, waiting } = usePost<Question>("Soru güncellendi");
  const [edited, setEdited] = useState(false);

  const handleEditClick = () => {
    setEdited(!edited);
  };

  // Handle potential null or undefined values
  if (!question || !question.options) return null;

  const handleSubmit = (updatedQuestion: Question) => {
    post(axiosApi.put<Result<Question>>(`api/questions`, updatedQuestion)).then(
      (r) => {
        setStateQuestion({
          ...question,
          answer: r.data.data!.answer,
          content: r.data.data!.content,
          explanation: r.data.data!.explanation,
          examTypeCategoryCode: r.data.data!.examTypeCategoryCode,
        });
        return r;
      }
    );
  };

  return (
    <Paper elevation={2} sx={{ mb: 2, p: 2 }}>
      {question.canceled && (
        <Typography color="error" variant="subtitle1" fontWeight="bold">
          <DoDisturbOnIcon
            sx={{ mr: 1, color: "red" }}
            fontSize="large"
            color="error"
          />
          {"İPTAL"}
        </Typography>
      )}
      <Typography variant="subtitle1" fontWeight="bold">
        Soru {question.number}:{" "}
        {`${showSection ? " - " : ""}
        ${showSection ? question.examSectionTypeCode : ""}`}
        {stateQuestion.examTypeCategory && (
          <Chip
            label={stateQuestion.examTypeCategory.categoryName}
            color="primary"
            size="small"
            sx={{ ml: 1 }}
          />
        )}
      </Typography>
      <IconButton
        sx={{ position: "absolute", top: 8, right: 8 }}
        onClick={handleEditClick}
      >
        <EditIcon color="primary" fontSize="small" />
      </IconButton>
      <Typography
        dangerouslySetInnerHTML={{ __html: stateQuestion.content }}
        sx={{ mb: 2 }}
      />

      {stateQuestion.imageId && (
        <Box sx={{ mb: 2 }}>
          <Typography color="error">
            (Bu soru için görsel mevcut, ancak şu anda gösterilemiyor)
          </Typography>
        </Box>
      )}

      <AnswerItems
        options={question.options}
        question={stateQuestion}
        showAnswers={showAnswers}
      />

      {showAnswers && stateQuestion.explanation && (
        <Box
          sx={{
            mt: 2,
            p: 1,
            bgcolor: "rgba(3, 169, 244, 0.1)",
            borderRadius: 1,
          }}
        >
          <Typography variant="subtitle2" fontWeight="bold">
            Açıklama:
          </Typography>
          <Typography
            dangerouslySetInnerHTML={{ __html: stateQuestion.explanation }}
          />
        </Box>
      )}
      <QuestionUpdateForm
        open={edited}
        initialQuestion={question}
        isLoading={waiting}
        onSubmit={handleSubmit}
        onClose={() => setEdited(false)}
      />
    </Paper>
  );
}

export default QuestionItem;
